<template>
	<div>
		<div class="imgCode-bg"></div>
		<div class="imgCodeBox">
			<div class="content">
				<span class="title">图片验证码</span>
				<div class="item-imgCode">
					<input type="text" v-model="imgCode" @blur="checkInput" maxlength="4" placeholder="请输入图片验证码" class="imgCode-input">
					<img :src="imgCodeUrl" class="imgCode" @click="freshValidateCode">
				</div>
				<div v-show="isError" class="error-p">
					<i class="icon-warning"></i>
					<span class="error">{{errorInfo}}</span>
				</div>
			</div>
			<div class="btns">
				<span class="btn" @click="cancel">取消</span>
				<span class="btn main-btn" @click="checkImgCode">确定</span>
			</div>
		</div>
	</div>
</template>
<script>
import login from '../../../util/login';
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			imgCode: '',
			imgCodeUrl: '',
			isError: false,
			errorInfo: '验证码输入错误'
		};
	},
	created() {
		this.freshValidateCode();
	},
	computed: {
		...mapGetters(['pagetypeLog'])
	},
	watch: {
		imgCode(val) {
			if (val.length === 4) {
				this.isError = false;
			}
		}
	},
	methods: {
		freshValidateCode() {
			this.imgCodeUrl = login.freshValidateCode();
		},
		checkInput() {
			if (this.imgCode === '') {
				this.errorInfo = '请输入验证码';
				window.clickLog &&
					window.clickLog(
						'from=jl_tupiancode_wrong' + this.pagetypeLog
					);
			} else if (this.imgCode.length < 4) {
				this.errorInfo = '验证码输入错误';
				window.clickLog &&
					window.clickLog(
						'from=jl_tupiancode_wrong' + this.pagetypeLog
					);
			}
		},
		checkImgCode() {
			if (this.imgCode === '') {
				this.errorInfo = '请输入验证码';
				window.clickLog &&
					window.clickLog(
						'from=jl_tupiancode_wrong' + this.pagetypeLog
					);
			} else if (this.imgCode.length < 4) {
				this.errorInfo = '验证码输入错误';
				window.clickLog &&
					window.clickLog(
						'from=jl_tupiancode_wrong' + this.pagetypeLog
					);
			} else {
				this.$emit('getCheckCode', this.imgCode);
				this.errorInfo = '验证码输入错误';
			}
			this.isError = true;
		},
		cancel() {
			this.$emit('closeImgBox');
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../../assets/style/public.scss';
.imgCode-bg {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0px;
	left: 0px;
	z-index: 999;
	background: rgba(148, 148, 148, 0.7);
}
.imgCodeBox {
	z-index: 1000;
	background: #ffffff;
	border-radius: 2px;
	position: absolute;
	width: px2rem(540px);
	height: px2rem(364px);
	left: 50%;
	top: 50%;
	margin-left: px2rem(-270px);
	margin-top: px2rem(-182px);
}
.content {
	margin: 0 px2rem(30px);
}
.title {
	display: block;
	font-size: px2rem(36px);
	color: #333333;
	letter-spacing: 0;
	line-height: px2rem(42px);
	width: 100%;
	text-align: center;
	margin: px2rem(60px) auto 0;
}
.item-imgCode {
	margin-top: px2rem(50px);
	position: relative;
}
.imgCode-input {
	width: 100%;
	height: px2rem(68px);
	line-height: px2rem(68px);
	padding-left: px2rem(2px);
	vertical-align: middle;
	font-size: px2rem(28px);
	color: #000000;
	border-bottom: 1px solid #eaeaea;
	box-sizing: border-box;
}
.imgCode {
	position: absolute;
	right: 0;
	top: 0;
	width: px2rem(130px);
	height: px2rem(66px);
}
.error-p {
	margin-top: px2rem(6px);
}
.icon-warning {
	display: inline-block;
	width: px2rem(26px);
	height: px2rem(26px);
	background: url(../../../assets/img/warning.png) no-repeat;
	background-size: contain;
	margin-top: px2rem(4px);
}
.error {
	font-size: px2rem(26px);
	color: #e60000;
}
.btns {
	width: 100%;
	border-top: 1px solid #f3f3f3;
	display: -moz-box;
	display: -webkit-box;
	display: box;
	position: absolute;
	bottom: 0;
	height: px2rem(90px);
	line-height: px2rem(90px);
	font-size: px2rem(34px);
	.btn:first-child {
		border-right: 1px solid #f3f3f3;
	}
}
.btn {
	color: #666;
	display: block;
	-moz-box-flex: 1;
	-webkit-box-flex: 1;
	box-flex: 1;
	width: 100%;
	text-align: center;
}
.main-btn {
	color: $orange;
}
</style>



// WEBPACK FOOTER //
// imgCode.vue?505a1848